import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { MaterialBoolControl } from 'console/shared/components/fields';
export const DeviceCustomContentSelection = memo(function DeviceCustomContentSelection(props) {
    const { item, items_ids, onTreeItemChange } = props;
    const option_ids = useMemo(() => {
        if (item.options) {
            return item.options.map(({ id }) => id);
        }
        return [];
    }, [item.options]);
    const is_item_selected = useMemo(() => (item.id && items_ids.includes(item.id)) ?? false, [item.id, items_ids]);
    const is_group_selected = useMemo(() => item.options?.every((option) => option.id ? items_ids.includes(option.id) : false) ?? false, [item.options, items_ids]);
    const is_in_group_selected = useMemo(() => item.options?.some((option) => option.id ? items_ids.includes(option.id) : false) ?? false, [item.options, items_ids]);
    const onGroupToggle = useCallback((value) => {
        const removed_selected_ids_from_group = items_ids.filter((id) => !option_ids.includes(id));
        onTreeItemChange(value
            ? [...removed_selected_ids_from_group, ...option_ids]
            : removed_selected_ids_from_group);
    }, [option_ids, items_ids]);
    const onItemToggle = useCallback((value) => {
        onTreeItemChange(value
            ? [...items_ids, item.id]
            : items_ids.filter((id) => item.id !== id));
    }, [item, items_ids]);
    if (item.options) {
        const selected_items_count = items_ids.filter((id) => option_ids.includes(id)).length;
        return (_jsxs(Box, { display: "flex", columnGap: 0.5, alignItems: "center", children: [_jsx(MaterialBoolControl, { value: is_group_selected, onChange: onGroupToggle, stopPropagation: true, indeterminate: is_in_group_selected && !is_group_selected }, item.name), _jsx(Typography, { color: "text.primary", fontSize: "1.2rem", children: item.name }), _jsx(Typography, { color: "text.primary", fontSize: "1rem", children: selected_items_count ? `(${selected_items_count})` : '' })] }));
    }
    return (_jsx(MaterialBoolControl, { value: is_item_selected, onChange: onItemToggle, custom_label: _jsx(Box, { display: "flex", alignItems: "center", children: _jsx(Typography, { children: item.name }) }) }, item.name));
});
